<template>

  <svg
    t="1632727376885"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6017"
    width="64"
    height="64"
  ><path d="M512 115.62576953L166.38971172 818.76394212 511.02275693 639.02275691 857.61028828 818.76394212Z" p-id="6018" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeArrow',
} as DefineComponent
</script>